import Store from "./Store";
import CommunicationPreferences from "../../model/communication-preferences.model";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export default class CommunicationPreferenceStore extends Store<CommunicationPreferences> {
  protected override name: string = "communication-preference";
}
